type SpacingValue = "none" | 2 | 5 | 10 | 15 | 20 | 40 | 60 | 100;

type SpacingTuple =
    | [all: SpacingValue]
    | [vertical: SpacingValue, horiztonal: SpacingValue]
    | [top: SpacingValue, horizontal: SpacingValue, bottom: SpacingValue]
    | [
          top: SpacingValue,
          right: SpacingValue,
          bottom: SpacingValue,
          left: SpacingValue,
      ];

export interface ISpacingComplete {
    left?: SpacingValue;
    top?: SpacingValue;
    right?: SpacingValue;
    bottom?: SpacingValue;
}

export type Spacing = SpacingValue | SpacingTuple | ISpacingComplete;

function isSpacingComplete(s: Spacing): s is ISpacingComplete {
    return typeof s === "object" && !Array.isArray(s);
}

function isSpacingTuple(s: Spacing): s is SpacingTuple {
    return typeof s === "object" && Array.isArray(s);
}

export const spacingStyles: { [key in SpacingValue]: string } = {
    none: "0",
    2: `${2 / 16}rem`,
    5: `${5 / 16}rem`,
    10: `${10 / 16}rem`,
    15: `${15 / 16}rem`,
    20: `${20 / 16}rem`,
    40: `${40 / 16}rem`,
    60: `${60 / 16}rem`,
    100: `${100 / 16}rem`,
};

export const spacing2 = spacingStyles[2];
export const spacing5 = spacingStyles[5];
export const spacing10 = spacingStyles[10];
export const spacing15 = spacingStyles[15];
export const spacing20 = spacingStyles[20];
export const spacing40 = spacingStyles[40];
export const spacing60 = spacingStyles[60];
export const spacing100 = spacingStyles[100];

export function spacing(s: Spacing): string {
    if (isSpacingComplete(s)) {
        return [s.top, s.right, s.bottom, s.left]
            .map(it => (it ? distance(it) : "0"))
            .join(" ");
    }

    if (isSpacingTuple(s)) {
        return s
            .filter((it): it is SpacingValue => typeof it !== "undefined")
            .map(distance)
            .join(" ");
    }

    return distance(s);
}

export function distance(value: SpacingValue) {
    return spacingStyles[value];
}
